const ActionTypes = {
  RESET: 'EVENT:BYO_RESET',
  RESET_SID: 'EVENT:BYO_RESET_BYO_SID',
  BYO_LOADING: 'EVENT:BYO_LOADING',
  BYO_LOADED: 'EVENT:BYO_LOADED',
  BYO_ERROR: 'EVENT:BYO_ERROR',
  PRICE_LOADING: 'EVENT:BYO_PRICE_LOADING',
  PRICE_LOADED: 'EVENT:BYO_PRICE_LOADED',
  PRICE_ERROR: 'EVENT:BYO_PRICE_ERROR',
  COMPLIANCE_LOADED: 'EVENT:COMPLIANCE_LOADED',
};

export default ActionTypes;
